import {
  LANGUAGE_PARAM,
  STORE_ID_PARAM,
} from "context/SiteSettingsContext/utils";
import { Fragment } from "react";
import { Route } from "react-router-dom";

type TLocalizedRouteGroupProps = {
  path: string;
  element: React.ReactNode;
  splat?: boolean;
};

export const LocalizedRouteGroup = ({
  path,
  element,
  splat = false,
}: Readonly<TLocalizedRouteGroupProps>) => {
  const suffix = splat ? "/*" : "";
  const pathWithStore = `/${STORE_ID_PARAM}${path}`;
  const pathWithStoreAndLang = `/${STORE_ID_PARAM}/${LANGUAGE_PARAM}${path}`;

  return (
    <Fragment>
      <Route path={`${path}${suffix}`} element={element} />
      <Route path={`${pathWithStore}${suffix}`} element={element} />
      <Route path={`${pathWithStoreAndLang}${suffix}`} element={element} />
    </Fragment>
  );
};
